// Source: https://github.com/steveops/kenyan-banks (banks.json, bank names only —
// branch-level codes aren't needed for a payout-account form). Fetched 2026-09-14.
// Note: this dataset predates several sector changes (Barclays Kenya -> Absa, Chase
// Bank -> SBM, CBA + NIC -> NCBA, K-Rep -> Sidian, Jamii Bora -> Kingdom Bank) — it's
// shipped as-is per the source requested, not corrected against current CBK licensing.
export const KENYAN_BANKS = [
  "AFRICAN BANKING CORPORATION",
  "BANK OF AFRICA KENYA LTD",
  "BANK OF BARODA",
  "BANK OF INDIA",
  "BARCLAYS BANK OF KENYA LIMITED",
  "CENTRAL BANK OF KENYA",
  "CHARTERHOUSE BANK LTD",
  "CHASE BANK (KENYA) LIMITED",
  "CITIBANK N.A.",
  "CO-OPERATIVE BANK",
  "COMMERCIAL BANK OF AFRICA LTD",
  "CONSOLIDATED BANK OF KENYA LTD",
  "CREDIT BANK LTD",
  "DEVELOPMENT BANK OF KENYA",
  "DIAMOND TRUST BANK",
  "DUBAI BANK OF KENYA LTD",
  "ECOBANK KENYA LTD",
  "EQUITORIAL COMMERCIAL BANK LTD",
  "EQUITY BANK",
  "FAMILY BANK LTD",
  "FIDELITY COMMERCIAL BANK",
  "FIRST COMMUNITY BANK",
  "GIRO BANK LTD",
  "GUARANTY TRUST (KENYA) LTD",
  "GUARDIAN BANK",
  "GULF AFRICAN BANK LTD",
  "HABIB BANK A.G.",
  "HABIB BANK LTD",
  "HOUSING FINANCE CORPORATION OF KENYA",
  "IMPERIAL BANK LIMITED",
  "INVESTMENTS AND MORTGAGES",
  "JAMII BORA BANK LTD",
  "K-REP BANK",
  "KENYA COMMERCIAL BANK LTD",
  "MIDDLE EAST BANK (K) LIMITED",
  "NATIONAL BANK OF KENYA",
  "NIC BANK",
  "ORIENTAL COMMERCIAL BANK",
  "PARAMOUNT UNIVERSAL BANK LTD",
  "PRIME BANK LIMITED",
  "STANBIC BANK KENYA LIMITED",
  "STANDARD CHARTERED",
  "TRANS-NATIONAL BANK",
  "UBA KENYA LTD",
  "VICTORIA COMMERCIAL BANK LTD",
];
